import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import CardTitle from '../../../../components/Commons/Elements/CardTitle'

import LastOrder from './LastOrder'

class LastOrders extends PureComponent {
  componentDidMount() {
    this.props.hydrateLastOrders && this.props.hydrateLastOrders()
  }

  render() {
    const {
      profile,
      openCustomerLastOrder,
      addCustomerLastCartItems,
    } = this.props

    const hasLastOrders = !!(
      profile.lastOrders &&
      profile.lastOrders.data &&
      profile.lastOrders.data.length > 0
    )

    if (!hasLastOrders) return null

    const lartOrders = profile.lastOrders.data

    return (
      <div className="mb7">
        <CardTitle i18nTextId="customerProfileLastOrdersSectionTitle" />
        <div className="cf items-center">
          {hasLastOrders ? (
            <div className="card-area-secondary">
              {lartOrders.map((lastOrder, index) => {
                return (
                  <LastOrder
                    key={lastOrder.orderId}
                    order={lastOrder}
                    onManageOrder={openCustomerLastOrder}
                    onAddToCart={addCustomerLastCartItems}
                    showBorder={index > 0}
                  />
                )
              })}
            </div>
          ) : (
            <div className="mid-gray suggestions-list">
              <FormattedMessage id="customerProfileNoLastOrdersTitle" />
            </div>
          )}
        </div>
      </div>
    )
  }
}

LastOrders.propTypes = {
  profile: PropTypes.object.isRequired,
  openCustomerLastOrder: PropTypes.func.isRequired,
  addCustomerLastCartItems: PropTypes.func.isRequired,
  hydrateLastOrders: PropTypes.func,
}

export default LastOrders
